function adminFeeMaster() {
	let feeMaster = [
		{
			name: "Fee Master",
			icon: "fee-master",
			logoName: "MyAccounts",
			// flag: "voucherRequired",
			displayService: "adminFeeMaster",
			items: []
		}
	];

	const dashboard = () => {
		const dashboardArr = [
			{
				path: "/index/AdminFee-Master",
				name: "Dashboard",
				icon: "dashboard",
				logoName: "dashboard",
				flag: "DASHBOARD"
			}
		];

		return dashboardArr;
	};

	const feeMasterSub = () => {
		const profileArr = [
			{
				path: "/index/FeeMaster",
				name: "Fee Master",
				icon: "feeMaster",
				logoName: "FEE",
				flag:"FEE MASTER"
				// flag: "isProfileSetting",
			}
		];

		// if (
		//   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
		// ) {
		return profileArr;
		// } else {
		//   return "";
		// }
	};

	let a = dashboard();
	let b = feeMasterSub();

	feeMaster[0].items = [...a, ...b];

	return feeMaster;
}

export default adminFeeMaster;
